import React from 'react';

import SidebarIconButton from './SidebarIconButton';

interface GoToFlowchartButtonProps {
  onClick: () => void;
}

/** @package */
export default function GoToFlowchartButton({onClick}: GoToFlowchartButtonProps): JSX.Element {
  return (
    <SidebarIconButton
      tooltip="View in flowchart"
      onClick={onClick}
      ariaLabel="View in flowchart"
      dataTestComponent="GoToFlowchartButton"
      icon="crosshairs"
    />
  );
}
